import { isEmpty } from "Util/isEmpty";
import { AppRoles } from "./AppRoles";
import { AvatarImage } from './AvatarImage';
import { ContactInfo } from './ContactInfo';
import { Nullable } from './Nullable';
import { SearchableEnumPresent } from "./PropertyMap";

export type AppUser = {
    id: string
    contactInfo: Nullable<ContactInfo>
    avatarImage: Nullable<AvatarImage>
    appRoles: SearchableEnumPresent<AppRoles.AppRoles>
}

export function noAppUserNameText(name?: Nullable<string>) {
    return isEmpty(name) ? 'Navnløst App Bruker' : name
}
